import React from "react";
import { Offcanvas, Table } from "react-bootstrap";
import { MdRestore } from "react-icons/md";
import Moment from "react-moment";
import { NoDataFoundTable, PageLoader } from "../../../../Components/NoDataFoundTable/NoDataFoundTable";

const DeletedLogRecord = ({ Show, Hide, Title, tableRef, onMouseDown, deletedLogRecordLoader, deletedLogRecordList, restoreStudySubjectLogRecord }) => {
  return (
    <Offcanvas show={Show} onHide={Hide} placement="end" style={{ width: "600px" }}>
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>{Title}</Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body className="p-0">
        {deletedLogRecordLoader ? (
          <PageLoader />
        ) : deletedLogRecordList?.length === 0 ? (
          <div className="hstack justify-content-center h-100">
            <NoDataFoundTable MSG={"Record not deleted yet."} />
          </div>
        ) : (
          <Table className="m-0 custom-table" hover striped ref={tableRef}>
            <thead className="position-sticky top-0 z-1">
              <tr>
                <th onMouseDown={(e) => onMouseDown(e, 0)} style={{ width: 45 }} className="text-center">
                  Sr.
                </th>
                <th onMouseDown={(e) => onMouseDown(e, 1)}>Record</th>
                <th onMouseDown={(e) => onMouseDown(e, 2)}>Deleted By</th>
                <th onMouseDown={(e) => onMouseDown(e, 3)}>Deleted At</th>
                <th onMouseDown={(e) => onMouseDown(e, 4)} style={{ width: 60 }} className="text-center">
                  Restore
                </th>
              </tr>
            </thead>
            <tbody>
              {deletedLogRecordList?.map((row, index) => (
                <tr key={row?.recordId || index}>
                  <td className="text-center">{index + 1}</td>
                  <td>Record {row?.recordNumber}</td>
                  <td>{row?.deletedByName || "-"}</td>
                  <td>
                    {row?.deletedAt ? (
                      <Moment format="DD MMM YYYY | HH:mm" withTitle>
                        {row?.deletedAt}
                      </Moment>
                    ) : (
                      "-"
                    )}
                  </td>
                  <td className="text-center" title={`Restore Record ${row?.recordNumber}`}>
                    <MdRestore
                      style={{ fontSize: 16 }}
                      className="text-success CP"
                      onClick={() => restoreStudySubjectLogRecord(row)}
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        )}
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default DeletedLogRecord;
